import { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Product from './pages/Product';
import Cart from './pages/Cart';
import NotFound from './pages/NotFound';
import { translate } from './lib/i18n';

// Pages most visitors never open are separate downloads, fetched when first visited
// (Layout shows a placeholder meanwhile). The admin panel is its own bundle too.
const Checkout = lazy(() => import('./pages/Checkout'));
const Installation = lazy(() => import('./pages/Installation'));
const Track = lazy(() => import('./pages/Track'));
const Login = lazy(() => import('./pages/Login'));
const Account = lazy(() => import('./pages/Account'));
const InfoPage = lazy(() => import('./pages/InfoPage'));
const InvoicePage = lazy(() => import('./components/Invoice'));
const AdminApp = lazy(() => import('./admin/AdminApp'));

const customerInvoice = (number) => `/api/account/orders/${encodeURIComponent(number)}`;
const adminInvoice = (id) => `/api/admin/orders/${encodeURIComponent(id)}`;

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (!hash) window.scrollTo(0, 0); }, [pathname, hash]);
  return null;
}

const standalone = (el) => <Suspense fallback={<div className="p-10 text-slate-500">{translate('Loading…')}</div>}>{el}</Suspense>;

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/admin/invoice/:id" element={standalone(<InvoicePage source={adminInvoice} backTo="/admin/orders" />)} />
        <Route path="/admin/*" element={<Suspense fallback={<div className="p-10 text-slate-500">{translate('Loading admin…')}</div>}><AdminApp /></Suspense>} />
        <Route path="/account/invoice/:number" element={standalone(<InvoicePage source={customerInvoice} backTo="/account/orders" />)} />
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="shop" element={<Shop />} />
          <Route path="product/:slug" element={<Product />} />
          <Route path="cart" element={<Cart />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="installation" element={<Installation />} />
          <Route path="track" element={<Track />} />
          <Route path="login" element={<Login />} />
          <Route path="about" element={<InfoPage slug="about" />} />
          <Route path="policies" element={<InfoPage />} />
          <Route path="policies/:slug" element={<InfoPage />} />
          <Route path="account/*" element={<Account />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}
